import { Api } from '@/munio/api/base'
import { CollectionResponse, ResourceResponse, RoleUserResourceDto } from '@/munio/api/data'

export default class UserRoles extends Api<{ user: number }> {
  constructor(userId: number) {
    super({
      user: userId,
    })
  }

  index() {
    return this.$get<CollectionResponse<RoleUserResourceDto>>(this.$route('api.web.admin.user.roles'))
  }

  enroll(roleId: number) {
    return this.$post<ResourceResponse<RoleUserResourceDto>>(
      this.$route('api.web.admin.user.role.enroll', { role: roleId }),
    )
  }

  unenroll(roleId: number) {
    return this.$delete<{ message: string } | void>(this.$route('api.web.admin.user.role.unenroll', { role: roleId }))
  }
}
